import React, { Component } from "react";
import { connect } from "react-redux";
import { isMobile } from 'react-device-detect';
import { Input, Select } from '../../ui';
import { setYatesValue, setClientValue } from "../../../actions";
import { yates } from "../../../operations";
import Text from '../../Common/Form/Text';
import { Body } from '../../Common/Form';
import Continue from "../../Common/Continue";
import {
  mapSelectList,
  numberBetween,
} from "../../../helpers";

import iconNumber from '../../../assets/icons/icon-number.svg';
import iconBoat from '../../../assets/icons/icon-embarcadiones-placer.svg';

class YateForm_2 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: false,
    };

    this.continueCondition = this.continueCondition.bind(this);
    this.getContent = this.getContent.bind(this);
  }

  componentDidMount() {
    this.checkContinueState(null);
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState);
  }

  continueCondition() {

    const {
      material, eslora,
      tipoBarco, accidente,
      manga, valor,
      bandera, velocidad
    } = this.props;

    return (
      material != null &&
      eslora != '' &&
      eslora >= 1 &&
      tipoBarco != null &&
      accidente != null &&
      accidente.value === '0' &&
      manga != '' &&
      manga >= 1 &&
      numberBetween(valor, 1, 60000) &&
      bandera != null &&
      velocidad != '' &&
      velocidad >= 1
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  getContent() {

    const {
      material, materialesSoloFibra,
      valor, eslora, manga, tipoBarco,
      tiposBarco, bandera, banderas,
      showError, velocidad, onValueChange,
      accidenteOpciones, accidente
    } = this.props;

    return (
      <div>
        <div className="Yates-formRow">
          <div style={{ flex: 1 }}>
            <Text style={{ paddingTop: '10px'}} className="Text-question">
              ¿De qué material es?
            </Text>
            <Select
              id="material"
              name="material"
              leftIcon={iconBoat}
              value={material}
              showAlert={showError && !material}
              onChange={(value) => { onValueChange('material', value) }}
              placeholder="Seleccione un material"
              searchable={!isMobile}
              options={mapSelectList(materialesSoloFibra)}
              autoComplete="nope"
            />
          </div>
          <div style={{ flex: 1 }}>
            <Text style={{ paddingTop: '10px'}} className="Text-question">
              ¿Cuál es su valor?
            </Text>
            <Input
              id="valor"
              name="valor"
              leftIcon={iconNumber}
              value={valor}
              showAlert={showError && !numberBetween(valor, 1, 60000)}
              onChange={(event) => { onValueChange('valor', event.target.value) }}
              placeholder="Valor en U$S (máx. 60.000)"
              type="number"
            />
          </div>
        </div>
        <div className="Yates-formRow">
          <div style={{ flex: 1 }}>
            <Text style={{ paddingTop: '10px'}} className="Text-question">
              ¿Cuál es la medida de eslora?
            </Text>
            <Input
              id="eslora"
              name="eslora"
              leftIcon={iconNumber}
              value={eslora}
              showAlert={showError && (!eslora || eslora < 1)}
              onChange={(event) => { onValueChange('eslora', event.target.value) }}
              placeholder="Medida en metros"
              type="number"
            />
          </div>
          <div style={{ flex: 1 }}>
            <Text style={{ paddingTop: '10px'}} className="Text-question">
              ¿Cuál es la medida de manga?
            </Text>
            <Input
              id="manga"
              name="manga"
              leftIcon={iconNumber}
              value={manga}
              showAlert={showError && (!manga || manga < 1)}
              onChange={(event) => { onValueChange('manga', event.target.value) }}
              placeholder="Medida en metros"
              type="number"
            />
          </div>
        </div>
        <div className="Yates-formRow">
          <div style={{ flex: 1 }}>
            <Text style={{ paddingTop: '10px'}} className="Text-question">
              ¿De que tipo es la embarcación?
            </Text>
            <Select
              id="tipoBarco"
              name="tipoBarco"
              leftIcon={iconBoat}
              value={tipoBarco}
              showAlert={showError && !tipoBarco}
              onChange={(value) => { onValueChange('tipoBarco', value) }}
              placeholder="Seleccione un tipo"
              searchable={!isMobile}
              options={mapSelectList(tiposBarco)}
              autoComplete="nope"
            />
          </div>
          <div style={{ flex: 1 }}>
            <Text style={{ paddingTop: '10px'}} className="Text-question">
              ¿Cuál es su bandera?
            </Text>
            <Select
              id="bandera"
              name="bandera"
              leftIcon={iconBoat}
              value={bandera}
              showAlert={showError && !bandera}
              onChange={(value) => { onValueChange('bandera', value) }}
              placeholder="Seleccione una bandera"
              searchable={!isMobile}
              options={mapSelectList(banderas)}
              autoComplete="nope"
            />
          </div>
        </div>
        <div className="Yates-formRow">
          <div style={{ flex: 1 }}>
            <Text style={{ paddingTop: '10px'}} className="Text-question">
              ¿Cuál es su velocidad máxima?
            </Text>
            <Input
              id="velocidad"
              name="velocidad"
              leftIcon={iconNumber}
              value={velocidad}
              showAlert={showError && (!velocidad || velocidad < 1)}
              onChange={(event) => { onValueChange('velocidad', event.target.value) }}
              placeholder="Velocidad en nudos"
              type="number"
            />
          </div>
          <div style={{ flex: 1 }}>
            <Text style={{ paddingTop: '10px'}} className="Text-question">
              ¿Sufrió algún accidente?
            </Text>
            <Select
              id="accidente"
              name="accidente"
              leftIcon={iconBoat}
              value={accidente}
              showAlert={showError && (!accidente || accidente.value === '1')}
              onChange={(value) => { onValueChange('accidente', value) }}
              placeholder="Marque Si o No (últimos 3 años)"
              searchable={!isMobile}
              options={mapSelectList(accidenteOpciones)}
              autoComplete="nope"
            />
          </div>
        </div>
        {accidente && accidente.value === '1' &&
          <span className="Text-Link">
            <Text style={{ paddingTop: '15px'}} className="Text-question">
              <span>No podrá avanzar con la compra.</span>
              <a href="mailto:cotizaciones@segurossura.com.uy " style={{color: 'var(--blue-color)', paddingLeft: '5px'}}>Solicitar cotización</a>
            </Text>
          </span>
        }
      </div>
    );
  }

  render() {

    const { continue: toContinue } = this.state;
    const { getQuotation } = this.props;

    return (
      <div>
        <Text style={{ paddingTop: '25px'}} className="Text-question Text-question--bold">
          Completá algunos datos adicionales de tu embarcación
        </Text>
        <Body columnContent={this.getContent} />
        <Continue state={toContinue} onClick={getQuotation} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,

    materiales: state.yates.materiales,
    materialesSoloFibra: state.yates.materialesSoloFibra,
    tiposBarco: state.yates.tiposBarco,
    banderas: state.yates.banderas,
    accidenteOpciones: state.yates.accidenteOpciones,

    material: state.yates.material,
    eslora: state.yates.eslora,
    tipoBarco: state.yates.tipoBarco,
    accidente: state.yates.accidente,

    manga: state.yates.manga,
    valor: state.yates.valor,
    velocidad: state.yates.velocidad,
    bandera: state.yates.bandera,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onClientValueChange: (type, value) => {
      dispatch(setClientValue(type, value));
    },
    onValueChange: (type, value) => {
      dispatch(setYatesValue(type, value));
    },
    getQuotation: () => {
      dispatch(yates.getQuotation());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(YateForm_2);